export class EntraRestoreReportEntityRequiredActionsInner {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "code",
            "baseName": "code",
            "type": "EntraRestoreReportEntityRequiredActionsInnerCodeEnum",
            "format": ""
        },
        {
            "name": "severity",
            "baseName": "severity",
            "type": "EntraRestoreReportEntityRequiredActionsInnerSeverityEnum",
            "format": ""
        },
        {
            "name": "detail",
            "baseName": "detail",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return EntraRestoreReportEntityRequiredActionsInner.attributeTypeMap;
    }
    constructor() {
    }
}
export var EntraRestoreReportEntityRequiredActionsInnerCodeEnum;
(function (EntraRestoreReportEntityRequiredActionsInnerCodeEnum) {
    EntraRestoreReportEntityRequiredActionsInnerCodeEnum["ReissueCredentials"] = "USER_REISSUE_CREDENTIALS";
    EntraRestoreReportEntityRequiredActionsInnerCodeEnum["ReregisterMfa"] = "USER_REREGISTER_MFA";
})(EntraRestoreReportEntityRequiredActionsInnerCodeEnum || (EntraRestoreReportEntityRequiredActionsInnerCodeEnum = {}));
export var EntraRestoreReportEntityRequiredActionsInnerSeverityEnum;
(function (EntraRestoreReportEntityRequiredActionsInnerSeverityEnum) {
    EntraRestoreReportEntityRequiredActionsInnerSeverityEnum["Required"] = "required";
})(EntraRestoreReportEntityRequiredActionsInnerSeverityEnum || (EntraRestoreReportEntityRequiredActionsInnerSeverityEnum = {}));
